import { __require as requireEmotionUseInsertionEffectWithFallbacks_cjs } from '../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.cjs.js';

var emotionUseInsertionEffectWithFallbacks_cjsExports = requireEmotionUseInsertionEffectWithFallbacks_cjs();

export { emotionUseInsertionEffectWithFallbacks_cjsExports as default };
//# sourceMappingURL=emotion-use-insertion-effect-with-fallbacks.cjs.js.map
